<template>
  <div class="docBox">
    <div class="menu-title">琼海智医管理平台-api接口操作手册</div>
    <p class="red">header:{token} 格式：md5(年-月-日*时间戳前7位)</p>
    <pre class="pre-text">
案例：md5(2025-05-01*1234567)
    </pre>
    <p class="red">API仅用于合作客户使用，禁止分享第三方使用，平台将追究其相应法律责任。</p>

    <div class="menu">
      <ul>
        <li>
          <a href="#quick=start">手动调用随访通知</a>
        </li>
      </ul>
    </div>

    <h1 id="quick-start">手动调用随访通知</h1>
    <p>请求方式：POST</p>
    <p>http://211.159.158.96:2547/javaRpc/send</p>
    <p class="red">请求参数说明：</p>
    <pre class="pre-text">
{
      "gzh_openid": "", //公众号用户openid
      "template_id": "", //模版id
      "template_msg": "" //模版内容，可选
}
    </pre>
    <p class="red">返回参数格式：</p>
    <pre class="pre-text">
{
	"data": "",
	"code": 200,
	"msg": "操作成功"
}
    </pre>

    <h1 id="kefu">其他问题</h1>
    <p>如有其他问题，请联系客服及时为您解答。</p>

    <!-- Back to Top Button -->
    <!-- <button class="back-to-top" @click="scrollToTop">↑</button> -->
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    scrollToTop() {
      // 检查浏览器是否支持配置对象
      if ("scrollTo" in window) {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        // 不支持配置对象时，使用传统的滚动方法
        window.scrollTo(0, 0);
      }
    }
  }
};
</script>

<style scoped>
.docBox {
  max-width: 80%;
  margin: 30px 20px;
  color: #313238;
  letter-spacing: 1.5px;
  padding: 0 5% 20% 5%;
}

.menu {
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.menu-title {
  font-size: 1.5em;
  margin-bottom: 10px;
  font-weight: 600;
  text-align: center;
}

h1 {
  font-size: 1.5em;
  margin-top: 2em;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 10px 0;
  display: block;
}

a {
  text-decoration: none;
  color: #8c8c8c;
  font-weight: bold;
  transition: color 0.3s, border-bottom-color 0.3s;
  border-bottom: 2px solid transparent;
  padding: 10px;
  display: block;
  transition: 0.5s;
}

a:hover {
  color: #fff;
  background: #adb68d;
}

p {
  margin: 10px 0;
  padding: 10px;
  font-size: 1em;
  line-height: 1.6;
  background-color: #f8f9fa;
  border-left: 4px solid #adb68d;
  border-radius: 4px;
}

img {
  margin: 10px;
  padding: 10px;
  max-height: 40vh;
  max-width: 90vw;
  object-fit: contain;
  border-radius: 10px;
  box-shadow: #ebebeb 1px 1px 10px;
}

.red {
  border-left: 5px solid #ff0000;
  color: #d95656;
}

.ImgBox {
  display: flex;
  flex-direction: row;
  overflow: auto;
  padding-bottom: 15px;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #ccd0b6;
  border-radius: 10px;
  border: 2px solid transparent;
}

::-webkit-scrollbar-thumb:hover {
  background-color: #afb68d;
}

.back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #adb68d;
  color: white;
  border: none;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  font-size: 1.5em;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s;
}

.back-to-top:hover {
  background-color: #8c8c8c;
}

.pre-text {
  background-color: #f8f9fa;
  padding: 10px;
}
</style>
